import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { ILotsListState } from './interfaces';
import { deleteRequest, getRequest } from 'api/requests';
import { ILot } from 'interfaces/main';
import { createLot } from 'features/CreateLotModal/CreateLotModalSlice';

// Замена лота в списке
export const exchangeLot = createAction(
  'lotsList/exchangeLot',
  (lot: ILot) => ({ payload: lot }),
);

// Загрузка списка логов
export const fetchLots = createAsyncThunk(
  'lotsList/fetchLots',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { user } = getState() as RootState;

      const response = await getRequest(
        'lot',
        [5].includes(user.roleId)
          ? {}
          : { organizationId: user.organizationId },
        true,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Удаление лота
export const removeLot = createAsyncThunk(
  'lotsList/removeLot',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await deleteRequest(`lot/${id}`, {}, true);

      return response.data.id;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Selectors
export const LotsListSelector = (state: RootState): ILotsListState =>
  state.lotsList;

export const LotsListLoadingSelector = createSelector(
  LotsListSelector,
  ({ isLoading }) => isLoading,
);

export const LotsListItemsSelector = createSelector(
  LotsListSelector,
  ({ items }) => items,
);

const initialState: ILotsListState = {
  isLoading: false,
  items: [],
};

const lotsListSlice = createSlice({
  name: 'lotsList',
  initialState,
  reducers: {
    exchangeLot: (state, { payload }) => ({
      ...state,
      items: state.items.map((item: ILot) =>
        item.id === payload.id ? payload : item,
      ),
    }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLots.pending, (state) => ({ ...state, isLoading: true }))
      .addCase(fetchLots.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(fetchLots.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: payload,
      }))
      .addCase(removeLot.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(removeLot.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(removeLot.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: state.items.filter((item: ILot) => item.id !== payload),
      }))
      .addCase(createLot.fulfilled, (state, { payload }) => ({
        ...state,
        items: [...state.items, payload],
      }));
  },
});

export default lotsListSlice.reducer;
